import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/shared/AuthContext';

// Layout
import Layout from './components/Layout';

// Production imports
import PatientHome from './pages/PatientHome';
import PatientChat from './pages/PatientChat';
import PatientMainDashboard from './pages/PatientMainDashboard';
import RoleBasedDashboard from './components/RoleBasedDashboard';
import TherapistPatients from './pages/TherapistPatients';
import TherapistAlerts from './pages/TherapistAlerts';
import TherapistAnalytics from './pages/TherapistAnalytics';
import PatientProfile from './pages/PatientProfile';
import PatientSettings from './pages/PatientSettings';
import PatientMemory from './pages/PatientMemory';
import PatientRadar from './pages/PatientRadar';

// Modern UI test pages
import HomeModern from './pages/HomeModern';
import Login from './pages/Login';
import Signup from './pages/Signup';
import TherapistSettings from './pages/TherapistSettings';
import PatientRadarMain from './pages/PatientRadarMain';
import { RadarChartProvider } from './context/shared/RadarChartContext';
import PatientWellness from './pages/PatientWellness';
import PatientMoodTracker from './pages/PatientMoodTracker';
import PatientNews from './pages/PatientNews';
import Legal from './pages/Legal';
import AdminApplicationPending from './pages/admin/AdminApplicationPending';
import TherapistClinicalTools from './pages/TherapistClinicalTools';
import TherapistConsole from './pages/TherapistConsole';
import TherapistInsights from './pages/TherapistInsights';
import PatientPortal from './pages/PatientPortal';
import PatientCalendar from './pages/PatientCalendar';
import PatientGroups from './pages/PatientGroups';
import TherapistReports from './pages/TherapistReports';
import TherapistPatientDetails from './pages/TherapistPatientDetails';

// Admin imports
import AdminRoute from './components/AdminRoute';
import TherapistApproval from './pages/admin/TherapistApproval';
import GrantAccessPage from './pages/admin/GrantAccess';
import GiftRequestReviewPage from './pages/admin/GiftRequestReview';
import GiftBatchReviewPage from './pages/admin/GiftBatchReview';
import GiftAnalyticsDashboard from './pages/admin/GiftAnalyticsDashboard';


function App() {
  const { isAuthenticated } = useAuth();
  
  return (
    <div className="App">
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/legal" element={<Legal />} />
        
        {/* Modern UI Test Routes */}
        <Route path="/test/home" element={<HomeModern />} />
        
        {/* Protected routes - only accessible when authenticated */}
        {isAuthenticated ? (
          <Route path="/*" element={<Layout />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<RoleBasedDashboard />} />
            <Route path="chat" element={<PatientChat />} />
            <Route path="settings" element={<TherapistSettings />} />
            <Route path="radar" element={
              <RadarChartProvider>
                <PatientRadarMain />
              </RadarChartProvider>
            } />
            <Route path="wellness" element={<PatientWellness />} />
            <Route path="mood-tracker" element={<PatientMoodTracker />} />
            <Route path="news" element={<PatientNews />} />
            <Route path="application-pending" element={<AdminApplicationPending />} />
            <Route path="clinical-tools" element={<TherapistClinicalTools />} />
            <Route path="patients" element={<TherapistPatients />} />
            <Route path="alerts" element={<TherapistAlerts />} />
            <Route path="analytics" element={<TherapistAnalytics />} />
            <Route path="profile" element={<PatientProfile />} />
            <Route path="patient-settings" element={<PatientSettings />} />
            <Route path="memory" element={<PatientMemory />} />
            <Route path="therapist/insights" element={<TherapistInsights />} />
            <Route path="patient-portal" element={<PatientPortal />} />
            <Route path="calendar" element={<PatientCalendar />} />
            <Route path="groups" element={<PatientGroups />} />
            <Route path="reports" element={<TherapistReports />} />
            <Route path="therapist/reports" element={<TherapistReports />} />
            <Route path="patient/:patientId" element={<TherapistPatientDetails />} />
            
            {/* Admin Routes */}
            <Route path="admin/*" element={<AdminRoute />}>
              <Route path="therapist-approval" element={<TherapistApproval />} />
              <Route path="grant-access" element={<GrantAccessPage />} />
              <Route path="gift-requests" element={<GiftRequestReviewPage />} />
              <Route path="gift-batch-review" element={<GiftBatchReviewPage />} />
              <Route path="gift-analytics" element={<GiftAnalyticsDashboard />} />
            </Route>
          </Route>
        ) : (
          /* Show login for all other routes when not authenticated */
          <Route path="*" element={<Login />} />
        )}
      </Routes>
    </div>
  );
}

export default App;
